<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { fade } from "svelte/transition";

    export let compound_list;

    export let main_compound;

    $: if (compound_list.length == 1) {
        main_compound = compound_list[0];
    }

</script>

<div class="input-group" id="compound_role_selection">
    {#if compound_list.length != 0}
        <p class="p-modal mt-2 col-12" in:fade|local={{ duration: 400 }}>
            Hauptzähler wählen
        </p>
    {/if}
    {#each compound_list as compound_water_meter, idx}
            <div
                class={main_compound == compound_water_meter
                    ? "main_meter col-7  meter-list-element"
                    : "col-7  meter-list-element"}
                in:fade|local={{ duration: 400 }}
            >
                <strong >{compound_water_meter.watermeterconfigs[0].alt_id} - {compound_water_meter.watermeterconfigs[0].name}</strong>
            </div>
            <div
                class={main_compound == compound_water_meter
                    ? "main_meter col-5  meter-list-element"
                    : "col-5  meter-list-element"}
                in:fade|local={{ duration: 400 }}
            >
                <label>
                    <input
                        type="radio"
                        bind:group={main_compound}
                        value={compound_water_meter}
                    /> Hauptzähler
                </label>
                <label > 
                    <input
                        type="radio"
                        checked={main_compound == compound_water_meter ? false : true}
                        on:click={() => {
                            if (main_compound == compound_water_meter) {
                                main_compound = null;
                            }
                        }}
                        value={compound_water_meter}
                    /> Nebenzähler
                </label>
            </div>
    {/each}
</div>
